export default __webpack_public_path__ + "static/media/DevSigin.e0f634ed.png";